import React from 'react'

import styled from '@emotion/styled'
import sv from '../styles/styles'

import AuthBase from "../components/AuthBase";
import AuthButton from "../components/AuthButton";
import {alertActionTypes} from "../_constants";
import AuthError from "../components/AuthError";
import {__isAvailable} from "../_helpers/commons/utility.helper";
import {AnimatedLoader, IsVerifying} from "../styles/CommonStyler";

// STYLE ##########################################################

const Actions = styled(`div`)`
  margin-top: 24px;
  ${sv.flexRow};
  justify-content: center;
  align-items: center;
`;

const Message = styled('div')`
  margin-bottom: 32px;
`;

// COMPONENT ##########################################################

function PseudoModal(props) {
    const {title, messages, submitText, cancelText, handleSubmit, handleCancel, alert, submittedProp = {}} = props;

    const messageElements = messages.map((message, key) =>
        <Message key={key}>{message}</Message>
    );

    const isSubmitted = () => __isAvailable(submittedProp) && submittedProp.submitted;

    return (
        <AuthBase title={title} maxWidth={props.maxWidth}>
            {alert && alert.type === alertActionTypes.ERROR &&
            <AuthError error={alert.message.errorMsg}/>
            }
            {messageElements}
            <Actions>
                {/* Shows up if no submission yet OR stays when no submittedProp passed */}
                {!isSubmitted() &&
                <>
                    <AuthButton cancel onClick={handleCancel}>{cancelText}</AuthButton>
                    <AuthButton onClick={handleSubmit} id="submit" disabled={props.disabled}>{submitText}</AuthButton>
                </>
                }

                {/* Shows up when submittedProp is passed and form is submitted */}
                {isSubmitted() &&
                <IsVerifying>
                    <h3>{submittedProp.pendingText}</h3>
                    <AnimatedLoader color={sv.colors.cta}/>
                </IsVerifying>
                }
            </Actions>
        </AuthBase>
    );
}

export default PseudoModal;
